//@ts-ignore
import PortalVue from "portal-vue";

export default defineNuxtPlugin({
  name: "portal",
  parallel: true,
  setup(app) {
    app.vueApp.use(PortalVue);
  },
});
